<!-- superadmin-workers.component.html -->

<div class="saw">

  <!-- ── Header ──────────────────────────────────── -->
  <div class="saw__header">
    <div>
      <h1 class="saw__title">All Workers</h1>
      <p class="saw__subtitle">Every field worker registered across all companies.</p>
    </div>
    <div class="saw__header-right">
      <div class="saw__search-wrap">
        <svg class="saw__search-icon" width="14" height="14" viewBox="0 0 24 24" fill="none">
          <circle cx="11" cy="11" r="8" stroke="currentColor" stroke-width="1.8"/>
          <path d="M21 21L16.65 16.65" stroke="currentColor" stroke-width="1.8" stroke-linecap="round"/>
        </svg>
        <input
          class="saw__search"
          type="text"
          placeholder="Search by name, email or company…"
          [(ngModel)]="searchQuery"
          (input)="applyFilter()"/>
      </div>

      <!-- Company filter -->
      <div class="saw__select-wrap">
        <svg class="saw__select-icon" width="13" height="13" viewBox="0 0 24 24" fill="none">
          <path d="M3 21V7L12 3L21 7V21" stroke="currentColor" stroke-width="1.8"
                stroke-linecap="round" stroke-linejoin="round"/>
        </svg>
        <select class="saw__select"
                [(ngModel)]="selectedCompany"
                (change)="applyFilter()">
          <option value="">All Companies</option>
          <option *ngFor="let c of companyNames" [value]="c">{{ c }}</option>
        </select>
      </div>

      <!-- Status toggle -->
      <div class="saw__toggle-group">
        <button class="saw__toggle-btn"
                [class.saw__toggle-btn--active]="statusFilter === 'all'"
                (click)="statusFilter = 'all'; applyFilter()">All</button>
        <button class="saw__toggle-btn"
                [class.saw__toggle-btn--active]="statusFilter === 'active'"
                (click)="statusFilter = 'active'; applyFilter()">Active</button>
        <button class="saw__toggle-btn"
                [class.saw__toggle-btn--active]="statusFilter === 'inactive'"
                (click)="statusFilter = 'inactive'; applyFilter()">Inactive</button>
      </div>
    </div>
  </div>

  <!-- ── Summary chips ───────────────────────────── -->
  <div class="saw__chips" *ngIf="!loading">
    <div class="saw__chip">
      <span class="saw__chip-dot saw__chip-dot--all"></span>
      <span class="saw__chip-label">Total Workers</span>
      <span class="saw__chip-val">{{ workers.length }}</span>
    </div>
    <div class="saw__chip">
      <span class="saw__chip-dot saw__chip-dot--active"></span>
      <span class="saw__chip-label">Active</span>
      <span class="saw__chip-val">{{ activeCount }}</span>
    </div>
    <div class="saw__chip">
      <span class="saw__chip-dot saw__chip-dot--inactive"></span>
      <span class="saw__chip-label">Inactive</span>
      <span class="saw__chip-val">{{ inactiveCount }}</span>
    </div>
    <div class="saw__chip">
      <span class="saw__chip-dot saw__chip-dot--company"></span>
      <span class="saw__chip-label">Companies</span>
      <span class="saw__chip-val">{{ companyNames.length }}</span>
    </div>
  </div>

  <!-- ── Table Card ──────────────────────────────── -->
  <div class="saw__card">

    <!-- Loading -->
    <div class="saw__loading" *ngIf="loading">
      <div class="saw__spinner"></div>
      <span>Loading workers…</span>
    </div>

    <!-- Empty -->
    <div class="saw__empty" *ngIf="!loading && filtered.length === 0">
      <svg width="44" height="44" viewBox="0 0 24 24" fill="none">
        <circle cx="9" cy="7" r="4" stroke="currentColor" stroke-width="1.4"/>
        <path d="M2 20C2 17 5 14 9 14" stroke="currentColor" stroke-width="1.4" stroke-linecap="round"/>
        <circle cx="17" cy="10" r="3" stroke="currentColor" stroke-width="1.4"/>
      </svg>
      <p>{{ searchQuery || selectedCompany ? 'No workers match your filters.' : 'No workers registered yet.' }}</p>
    </div>

    <!-- Table -->
    <div class="saw__table-wrap" *ngIf="!loading && filtered.length > 0">
      <table class="saw__table">
        <thead>
          <tr>
            <th class="saw__th">Worker</th>
            <th class="saw__th">Company</th>
            <th class="saw__th">Email</th>
            <th class="saw__th saw__th--center">Logs</th>
            <th class="saw__th saw__th--center">Status</th>
          </tr>
        </thead>
        <tbody>
          <tr class="saw__row" *ngFor="let w of pagedWorkers">

            <!-- Worker -->
            <td class="saw__td">
              <div class="saw__worker-cell">
                <div class="saw__avatar" [style.background]="getAvatarColor(w.id)">
                  {{ getInitials(w.fullName) }}
                </div>
                <div class="saw__worker-info">
                  <span class="saw__worker-name">{{ w.fullName }}</span>
                  <span class="saw__worker-id">ID: {{ w.id | slice:0:8 }}…</span>
                </div>
              </div>
            </td>

            <!-- Company -->
            <td class="saw__td">
              <div class="saw__company-pill">
                <div class="saw__company-dot">
                  {{ w.companyName?.charAt(0)?.toUpperCase() }}
                </div>
                <span class="saw__company-name">{{ w.companyName }}</span>
              </div>
            </td>

            <!-- Email -->
            <td class="saw__td saw__td--muted">
              <a class="saw__email-link" href="mailto:{{ w.email }}">{{ w.email }}</a>
            </td>

            <!-- Logs -->
            <td class="saw__td saw__td--center">
              <span class="saw__log-count"
                    [class.saw__log-count--zero]="w.logCount === 0">
                {{ w.logCount }}
              </span>
            </td>

            <!-- Status -->
            <td class="saw__td saw__td--center">
              <span class="saw__status"
                    [class.saw__status--active]="w.isActive"
                    [class.saw__status--inactive]="!w.isActive">
                <span class="saw__status-dot"></span>
                {{ w.isActive ? 'Active' : 'Inactive' }}
              </span>
            </td>

          </tr>
        </tbody>
      </table>

      <!-- Pagination -->
      <div class="saw__pagination" *ngIf="totalPages > 1">
        <span class="saw__pagination-info">
          Showing {{ (currentPage - 1) * pageSize + 1 }}–{{ Math.min(currentPage * pageSize, filtered.length) }}
          of {{ filtered.length }} workers
        </span>
        <div class="saw__pagination-controls">
          <button class="saw__page-btn"
                  (click)="goToPage(currentPage - 1)"
                  [disabled]="currentPage === 1">
            <svg width="13" height="13" viewBox="0 0 24 24" fill="none">
              <path d="M15 18L9 12L15 6" stroke="currentColor" stroke-width="2"
                    stroke-linecap="round" stroke-linejoin="round"/>
            </svg>
          </button>
          <button class="saw__page-btn saw__page-btn--num"
                  *ngFor="let p of pageNumbers"
                  [class.saw__page-btn--active]="p === currentPage"
                  (click)="goToPage(p)">{{ p }}</button>
          <button class="saw__page-btn"
                  (click)="goToPage(currentPage + 1)"
                  [disabled]="currentPage === totalPages">
            <svg width="13" height="13" viewBox="0 0 24 24" fill="none">
              <path d="M9 18L15 12L9 6" stroke="currentColor" stroke-width="2"
                    stroke-linecap="round" stroke-linejoin="round"/>
            </svg>
          </button>
        </div>
      </div>

    </div>
  </div>

</div>